<template>
  <div class="mfaq-home">
    <div class="card-wrap" :class="{ 'need-one': needOne }">
      <ai-card
        v-for="item in sectionList"
        :key="item.sectionId"
        :item="item"
        :limit="5"
      >
      </ai-card>
      <div v-if="showNoDataImg" class="no-data-wrap">
        <img :src="noDataImg" alt="NO DATA" />
        <p class="no-data-text">{{ $t("index.list.noData") }}</p>
      </div>
    </div>
  </div>
</template>
<script>
import { loadAccountSection, loadAppFaqSection, searchFAQ } from "@/api/index";
import resultMixin from "./component/resultMixin.js";
import noDataImg from "@/assets/no_data.png";
import store from "@/vuex/index";

export default {
  name: "mfaqHome",
  mixins: [resultMixin],
  components: {
    aiCard: () => import("./component/aiCard")
  },
  props: {
    loadings: Object
  },
  data() {
    return {
      sectionList: [],
      noDataImg: noDataImg
    };
  },
  // 进入页面
  beforeRouteEnter(to, from, next) {
    next(vm => {
      // account:http://localhost:8080/faq/#/%E5%BE%AE%E4%BF%A1%E6%8E%A5%E5%85%A5%E6%B5%8B%E8%AF%95/account/en/B9B327B6DA1EFF8D
      // app: http://localhost:8080/faq/#/Chatter-Bot/app/en/671381DAED9A8C7E
      vm.dispatchInit(to.params);
    });
  },
  // 路由改变
  beforeRouteUpdate(to, form, next) {
    // let { gameName, page, alias, gameIdKey } = to;
    this.dispatchInit(to.params);
    next();
  },
  mounted() {
    // 监听平台变化
    this.$bus.$on("paltform-change", val => {
      // let { gameName, page, alias, gameIdKey } = this.$route.params;
      this.dispatchInit(this.$route.params);
    });
    // this.$bus.pageInfo.isFirst = false
  },
  computed: {
    hasContentLen() {
      let contents = this.sectionList.reduce((sum, item) => {
        if (item.contentList.length === 0) return sum;
        return sum + 1;
      }, 0);
      return contents;
    },
    needOne() {
      let len = this.hasContentLen;
      // 2, 5, 8, 11, 14
      return len % 3 === 2;
    },
    showNoDataImg: {
      get() {
        let flag = this.sectionList.some(item => {
          return item.contentList.length > 0;
        });
        return !flag;
      },
      set(val) {}
    }
  },
  methods: {
    dispatchInit(params) {
      let { alias, gameName, page, gameIdKey: key } = params;
      let gameIdKey = this.$bus.pageInfo.gameIdKey || key;
      this.showNoDataImg = false;
      page =
        page == "account" && this.$bus.pageInfo.isFirst ? "account" : "app";
      let platform = this.$bus.pageInfo.platform;
      //lyh 由于历史项目组件嵌套层次过深 引入vuex 做H5数据初始化统一管理
      store.commit("CHANGELANGUAGE", alias);
      if (page === "account") {
        this.accountInit(gameIdKey, alias, platform);
        this.$bus.pageInfo.isFirst = false;
      } else if (page === "app") {
        this.appChange(gameIdKey, alias, platform);
      }
    },
    // 账号初始化
    accountInit(key, alias, platform) {
      this.$bus.$emit("loading", this.loadings);
      loadAccountSection(key, alias, platform)
        .then(res => {
          if (!localStorage.getItem("reloaded")) {
            localStorage.setItem("reloaded", "1");
            let navigatorLanguage = (
              navigator.language || navigator.browserLanguage
            ).toLowerCase(); //常规浏览器语言和IE浏览器
            if (navigatorLanguage != alias.toLowerCase()) {
              res.languageList.map(item => {
                if (item.alias.toLowerCase() === navigatorLanguage) {
                  alias = item.alias;
                  let path = this.getPath("alias", alias);
                  this.$router.push({ path });
                  window.location.reload();
                }
              });
            }
          }
          this.initFilter(res, key, alias);
          //由于历史项目组件嵌套层次过深 引入vuex 做H5数据初始化统一管理
          store.commit("CHANGEISSHOWH5", res.isShowH5);
          store.commit("CHANGEAPPID", res.appId);
          store.commit("CHANGEAPPNAME", res.displayName);
          store.commit("CHANGEACCOUNTID", res.accountId);
        })
        .catch(err => {});
    },
    // 应用初始化
    appChange(key, alias, platform) {
      this.$bus.$emit("loading", this.loadings);
      loadAppFaqSection(key, alias, platform)
        .then(res => {
          if (!localStorage.getItem("reloaded")) {
            localStorage.setItem("reloaded", "1");
            let navigatorLanguage = (
              navigator.language || navigator.browserLanguage
            ).toLowerCase(); //常规浏览器语言和IE浏览器
            if (navigatorLanguage != alias.toLowerCase()) {
              res.languageList.map(item => {
                if (item.alias.toLowerCase() === navigatorLanguage) {
                  alias = item.alias;
                  let path = this.getPath("alias", alias);
                  this.$router.push({ path });
                  window.location.reload();
                }
              });
            }
          }
          this.initFilter(res, key, alias);
          store.commit("CHANGEISSHOWH5", res.isShowH5);
          store.commit("CHANGEAPPID", res.appId);
          store.commit("CHANGEAPPNAME", res.displayName);
          store.commit("CHANGEACCOUNTID", res.accountId);
        })
        .catch(err => {});
    },
    // 返回跳转路径
    getPath(key, value) {
      let params = this.$route.params;
      params[key] = value;
      let path = "/gameName/page/alias/gameIdKey";
      Object.keys(params).forEach(key => {
        path = path.replace(key, params[key]);
      });
      return path;
    }
  },
  beforeDestroy() {
    // this.$bus.$off("change-platform");
    this.$bus.$off("paltform-change");
  }
};
</script>
<style lang="scss">
@import "~@/style/media.scss";
.mfaq-home {
  //
  .main {
    padding: 20px 30px;
    .card-wrap {
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;
      // card 为2, 5, 8... 时 处理布局
      @include media-min-md {
        &.need-one {
          &:after {
            content: "";
            width: 26%;
            height: 150px;
          }
        }
      }
    }
    .mfaq-home,.faq-detail,.mfaq-faqList,.faq-list,.mfaq-faqList {
      max-width: 1200px;
      padding: 0px 30px 20px;
      margin: 0 auto;
    }
  }
  .no-data-wrap {
    width: 100%;
    text-align: center;
    margin-top: 80px;
    .no-data-text {
      margin-top: 20px;
    }
  }
}
</style>>